import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { AuthenticationService } from '@authentication/authentication.service';
import { MessageService } from '@shared/services/message.service';
import { GoogleDriveService } from '@app/modules/shared/services/google-drive/google-drive.service';
import { GoChatCacheService } from '@app/modules/therapist/go-chat/go-chat-cache.service';
import { GoCoreChatService } from '@shared/services/gocore/chat/gocore-chat.service';
import { DialogComponent as DialogComponent_1 } from '../../../shared/components/dialog/dialog.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-logout-confirmation-dialog',
  templateUrl: './logout-confirmation-dialog.component.html',
  imports: [DialogComponent_1],
})
export class LogoutConfirmationDialogComponent {
  private dialogRef = inject<MatDialogRef<LogoutConfirmationDialogComponent>>(MatDialogRef);
  private authenticationService = inject(AuthenticationService);
  private googleDriveService = inject(GoogleDriveService);
  private messageService = inject(MessageService);
  private goCoreChatService = inject(GoCoreChatService);
  private goChatCacheService = inject(GoChatCacheService);

  readonly loggingOut = signal(false);
  public title = 'Are you sure that you want to log out?';

  public async logOutButtonClicked(): Promise<void> {
    this.loggingOut.set(true);
    try {
      this.title = 'Revoking Access Token...';
      void this.googleDriveService.revokeAccessTokenConsent();
      this.title = 'Sending Pending Messages...';
      await this.goCoreChatService.waitForPendingMessagesToSend();
      this.title = 'Deleting Chat Cache...';
      await this.goChatCacheService.deleteChatCache();
      this.title = 'Logging Out...';
      await this.authenticationService.logOut();
      this.title = 'Successfully Logged Out!';
      this.dialogRef.close();
    } catch {
      this.dialogRef.close();
      this.messageService.showMessage('Error: Could not log out. Please try again.');
    } finally {
      this.loggingOut.set(false);
    }
  }

  public cancelButtonClicked(): void {
    this.dialogRef.close();
  }
}
